import script from "./FormStepNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FormStepNav.vue?vue&type=script&setup=true&lang=js"

import "./FormStepNav.vue?vue&type=style&index=0&id=53f1d8d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f1d8d3"]])

export default __exports__